import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sort",
  "use": "icon-sort-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sort\"><path d=\"M156.392727 656.523636a43.52 43.52 0 0 1 61.207273 7.214546l113.105455 144.058182V90.298182a43.752727 43.752727 0 1 1 87.272727 0v843.403636a43.752727 43.752727 0 0 1-29.323637 41.425455 42.123636 42.123636 0 0 1-14.196363 2.327272 43.287273 43.287273 0 0 1-34.210909-16.756363L148.945455 717.730909a43.52 43.52 0 0 1 7.447272-61.207273zM634.414545 48.872727a43.752727 43.752727 0 0 1 48.64 14.429091l191.069091 242.967273a43.752727 43.752727 0 1 1-69.818181 53.992727l-111.941819-144.058182v717.498182a43.752727 43.752727 0 1 1-87.272727 0V90.298182a44.218182 44.218182 0 0 1 29.323636-41.425455z\" p-id=\"1565\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/sort.svg
// module id = Nbau
// module chunks = 78